export const Functions = {
    sin: {
        keyword: "sin",
        group: "MathematicalFunctions",
        name: "SIN_FUNCTION",
        precedence: 1000,
        arguments: 1,
        description: "sinus of angle in radians"
    }
};